import { ReceivingProductRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ReceivingProductService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ReceivingProductRouteService());
	}

	find = filter => {
		const url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	};
}

export default ReceivingProductService;



// WEBPACK FOOTER //
// ./src/common/data/services/ReceivingProductService.js